module.exports = __webpack_public_path__ + "static/cliente_1-4d07208ce6e85c63a5e85880a5515a96.png";